import cx from 'classnames';
import * as React from 'react';

import Text from 'components/Text';

import './styles/Label.scss';

export type Props = {
  checked?: boolean;
  children: React.ReactNode;
  className?: string;
  // Visually hidden, but preserved screenreaders
  hidden?: boolean;
  // Native `for` attribute
  htmlFor?: string;
  // Supplemental copy
  note?: React.ReactNode;
  // Allows you to add another inline component to the label note. i.e. Link
  customNote?: React.ReactNode;
};

export function asterisked(text: React.ReactNode) {
  return (
    <span>
      {text} <Text color="apple">*</Text>
    </span>
  );
}

export default class Label extends React.Component<Props> {
  render() {
    const { checked, children, className, hidden, htmlFor, note, customNote, ...others } =
      this.props;

    return (
      <label
        {...others}
        htmlFor={htmlFor}
        className={cx('Label', hidden && 'Label--hidden', className)}
      >
        <Text weight="semibold">{children}</Text>
        {note || customNote ? (
          <div className="Label--noteContainer">
            {note && (
              <Text
                color={checked ? 'inherit' : 'graphite'}
                element="div"
                weight="normal"
                className="Label-note"
              >
                {note}
              </Text>
            )}
            {customNote ? customNote : null}
          </div>
        ) : null}
      </label>
    );
  }
}
